import * as React from 'react';
import styled from 'styled-components';

import { focusOutline, media, textClip, transition } from '../../../styles/mixins';
import { RemixIcon } from '../../shared/remix-icon';

type Props = {
	prevRef: React.Ref<HTMLButtonElement>;
	nextRef: React.Ref<HTMLButtonElement>;
	prevRemix: string;
	nextRemix: string;
	isEnabled: boolean;
};

export const MainNavigationButton = ({
	prevRef,
	nextRef,
	prevRemix,
	nextRemix,
	isEnabled,
}: Props) => {
	return (
		<>
			<NavigationButton
				aria-label="Previous slides"
				data-direction="prev"
				ref={prevRef}
				data-enabled={isEnabled}
			>
				<ButtonRemixIcon className={prevRemix} />
			</NavigationButton>
			<NavigationButton
				aria-label="Next slides"
				data-direction="next"
				ref={nextRef}
				data-enabled={isEnabled}
			>
				<ButtonRemixIcon className={nextRemix} />
			</NavigationButton>
		</>
	);
};

const NavigationButton = styled.button`
	--size: 56px;

	position: absolute;
	top: 50%;

	&[data-enabled='false'] {
		display: none;
	}

	&[data-direction='prev'] {
		left: calc(0px - var(--size) - 8px);

		&:after {
			left: 0;
			background-position: left;
		}
	}

	&[data-direction='next'] {
		right: calc(0px - var(--size) - 8px);

		&:after {
			right: 0;
			background-position: right;
		}
	}

	display: none;
	flex-direction: row;
	align-items: center;
	padding: 16px;
	gap: 4px;

	width: var(--size);
	height: var(--size);

	background: ${(p) => p.theme.colors.headerBlack} !important;

	border: none;
	cursor: pointer;
	transform: translateY(-50%);

	&:after {
		content: '';
		position: absolute;

		top: 0;
		height: 100%;
		width: 100%;

		background: ${(p) => p.theme.gradients.button.hover.primary};
		background-size: 3px 100%;
		background-repeat: no-repeat;

		${transition('background-size')};

		z-index: -1;
	}

	&:focus-visible,
	&:hover {
		&:after {
			background-size: 100% 100%;
		}
	}

	&:focus-visible {
		${focusOutline()};
	}

	${media.lg`
		display: flex;
	`};
`;

const ButtonRemixIcon = styled((props) => <RemixIcon {...props} />)`
	font-size: 20px;
	line-height: 20px;

	background: ${(p) => p.theme.gradients.white};

	${textClip()};
`;
